import React, { Component } from 'react'
import { AppGridLayoutContext } from './AppGridLayout'
import { AppGridView as AppGridViewPRops } from 'api'

export default class AppGridView extends Component<AppGridViewPRops> {
	render() {
		return (
			<AppGridLayoutContext.Consumer>
				{context => {
					return this.props.viewId === context.viewId ? (
						<div
							className="app-grid-view"
							ref={context.refAppGridView}
							style={{ height: context.viewHeight }}
						>
							{this.props.children}
						</div>
					) : (
						''
					)
				}}
			</AppGridLayoutContext.Consumer>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridView.tsx